module.exports = __webpack_public_path__ + "static/media/logo_blanco.3b05db3a.png";